function ExperienceItem({ item, isOpen, onToggle }) {
    if (item.details.length === 0) {
        return (
            <div className="line-item current-role">
                <span className="experience-title">
                    <strong>{item.company}</strong>
                    <span>{item.role}</span>
                </span>
                <time>{item.date}</time>
            </div>
        );
    }

    return (
        <div className={`experience-item${isOpen ? ' is-open' : ''}`}>
            <button
                type="button"
                className="line-item experience-summary"
                aria-expanded={isOpen}
                onClick={onToggle}
            >
                <span className="experience-title">
                    <strong>{item.company}</strong>
                    <span>{item.role}</span>
                </span>
                <time>{item.date}</time>
            </button>
            <div className="experience-detail-shell" aria-hidden={!isOpen}>
                <div className="experience-detail">
                    <div className="experience-detail-content">
                        <p>{item.location}</p>
                        <ul>
                            {item.details.map((detail) => <li key={detail}>{detail}</li>)}
                        </ul>
                        <p className="experience-stack">{item.stack}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExperienceItem;
